import { useDataChange } from 'Simple/Data.js'

export default function useDataOnChange(props, data) {
  let change = useDataChange({
    context: 'tab',
    path: 'selected.apps_filter',
    viewPath: props.viewPath,
  })

  return function onChange(value) {
    change(
      value.some(item => item.companies.some(item => item.status === 'granted'))
        ? 'installed'
        : 'directory'
    )
  }
}
